var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsultationsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chat-icon",
    transform: "translate(-320 -753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blankbox",
    width: 16,
    height: 16,
    transform: "translate(320 753)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat-line",
    transform: "translate(322.071 755.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4306",
    "data-name": "Path 4306",
    d: "M6,0A5.924,5.924,0,0,0,0,6a6.019,6.019,0,0,0,6.066,5.851H9.941a1.91,1.91,0,0,0,1.908-1.908V6.067A6.019,6.019,0,0,0,6,0m5.05,9.94a1.108,1.108,0,0,1-1.107,1.107H6.067A5.215,5.215,0,0,1,.8,5.988,5.123,5.123,0,0,1,5.924.8h.064a5.215,5.215,0,0,1,5.059,5.265Z",
    transform: "translate(0 -0.001)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    d: "M50.345,51.446H52.9a.4.4,0,0,0,0-.8H50.345a.4.4,0,1,0,0,.8",
    transform: "translate(-46.481 -47.133)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4308",
    "data-name": "Path 4308",
    d: "M54.846,79.656h-4.5a.4.4,0,1,0,0,.8h4.5a.4.4,0,1,0,0-.8",
    transform: "translate(-46.482 -74.132)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    d: "M54.846,108.668h-4.5a.4.4,0,1,0,0,.8h4.5a.4.4,0,1,0,0-.8",
    transform: "translate(-46.482 -101.133)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultationsIcon);
export default __webpack_public_path__ + "static/media/consultations-icon.dfa0e0bf8c78a75626c056bc532cb256.svg";
export { ForwardRef as ReactComponent };